import React from 'react';
import { Checkbox } from '@mui/material';
import RoundBgTick from "assets/img/svg/svgComponents/RoundBgTick";

const CheckBoxCircle = () => <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <circle cx="12.5" cy="12" r="10" stroke="#E2E2E2" stroke-width="1.5" />
</svg>

const RoundCheckbox = ({
    isChecked,
    onChange,
    isDisabled = false
}) => {
    return (
            <Checkbox
                checked={isChecked}
                onChange={(e) => onChange(e.target.checked)}
                icon={<CheckBoxCircle />}
                checkedIcon={<RoundBgTick />}
                disabled={isDisabled}
            />

    );
}

export default RoundCheckbox;